import { Loader } from '@olino/design-system'

const Loading: React.FC = () => (
  <div className="flex h-screen max-h-full w-full items-center justify-center overflow-hidden">
    <Loader size="big" />
  </div>
)

export default Loading
